/** Contrato do preview de importação — espelha `importacao.service.ts` (Épico 7). */

export interface Divergencia {
  referencia: string;
  tabela: string;
  priceSourceKey: string;
  valorAnterior: string;
  valorNovo: string;
  /** Variação em %, com sinal (`"+3.75"`). `"n/d"` quando a base era zero. */
  variacaoPercent: string;
}

/**
 * Preço que a draft tem e a vigente não tinha — uma ADIÇÃO.
 *
 * Antes da UX.3 o backend descartava estes silenciosamente, e a tela dizia
 * "Efetivar não mudaria nada" enquanto uma tabela inteira entrava.
 */
export interface PrecoNovo {
  referencia: string;
  tabela: string;
  priceSourceKey: string;
  valor: string;
}

/** Preço que a vigente tinha e a draft não tem — uma REMOÇÃO por coluna. */
export interface PrecoRemovido {
  referencia: string;
  tabela: string;
  priceSourceKey: string;
  valorAnterior: string;
}

/** O diff somado por tabela — "entrou a coluna X com N preços". */
export interface ResumoPorTabela {
  tabela: string;
  novos: number;
  alterados: number;
  removidos: number;
  inteiraNova: boolean;
  inteiraRemovida: boolean;
}

export type CampoFicha =
  'pesoBrutoUnidade' | 'medidaCaixa' | 'formato' | 'ipi' | 'unidade' | 'classe';

/**
 * Mudança na ficha de um produto que já existia.
 *
 * Até a Story 8.4 esses campos eram sobrescritos sem ninguém ver. Peso errado
 * muda o frete de **todo** orçamento futuro daquela referência — por isso a
 * lista aparece no preview com o mesmo destaque das divergências de preço.
 */
export interface MudancaFicha {
  referencia: string;
  campo: CampoFicha;
  de: string | null;
  para: string | null;
}

export interface Preview {
  versionId: string;
  status: string;
  comparadaCom: string | null;
  novos: string[];
  removidos: string[];
  semPreco: string[];
  divergencias: Divergencia[];
  /** Amostras — o total vem no `resumo`, a conta por tabela em `porTabela`. */
  precosNovos: PrecoNovo[];
  precosRemovidos: PrecoRemovido[];
  porTabela: ResumoPorTabela[];
  mudancasFicha: MudancaFicha[];
  /**
   * Rodapés que esta carga CRIOU e que ainda são vendidos por caixa — S11.
   *
   * Opcional pelo deploy escalonado (web novo, API antiga): ausente é lista
   * vazia. Some da lista quando a barra é configurada no produto.
   */
  rodapesNovosPorCaixa?: string[];
  resumo: {
    produtosNaDraft: number;
    novos: number;
    removidos: number;
    semPreco: number;
    divergencias: number;
    mudancasFicha: number;
    rodapesNovosPorCaixa?: number;
    precosNovos: number;
    precosRemovidos: number;
  };
}

/** Rótulo legível — a tela não mostra camelCase para o admin. */
export const ROTULO_CAMPO: Record<CampoFicha, string> = {
  pesoBrutoUnidade: 'Peso bruto / unidade',
  medidaCaixa: 'Medida por caixa',
  formato: 'Formato',
  ipi: 'IPI',
  unidade: 'Unidade',
  classe: 'Classe',
};
